// libs
import styled from "styled-components";
// theme
import { typography, colors } from "src/theme";
import device from "src/constants/media";

const Wrapper = styled.div`
  user-select: none;

  .pagination_container {
    cursor: pointer;
    list-style: none;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    min-height: 40px;

    @media ${device.tablet} {
      align-items: flex-start;
      justify-content: start;
    }

    li {
      font-family: ${typography.fontFamily};
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      color: ${colors.grey};
      width: 40px;
      height: 40px;
      flex-grow: 0;
      margin: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;

      a {
        color: ${colors.greyDark};
        min-width: 100%;
        height: 100%;
        padding: 9px 0;
      }
      :hover {
        background-color: ${colors.mainVeryLight};
      }
    }
  }

  .pagination_previous,
  .pagination_next {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${colors.greyVeryLight};
  }

  .pagination_active {
    background-color: ${colors.mainLight};
  }
`;
export default Wrapper;
